import React, { useState, useRef, forwardRef, useImperativeHandle } from 'react';
import { Grid, Button } from '@material-ui/core';

import FinancialInformation from '../../component/FinancialInformation/v2';
import IncomeTable from '../../component/IncomeTable';
import Modal from '../../component/Modal';
// [AZLF-133] Sample tax pages for families
import TaxFormSamples from '../../component/TaxFormSamples';

const DDFinancialInformationV2 = ({ application, account, lock }, ref) => {
	const [openModal, setOpenModal] = useState(false);
	const financialInformationRef = useRef(null);

	useImperativeHandle(ref, () => ({
		saveFinancialOnSubmit: () => financialInformationRef.current?.saveFinancialOnSubmit(),
		openFirstFinancial: () => financialInformationRef.current.openFirstFinancial(),
	}));

	const { previousPeriod } = application;
	const previous = previousPeriod == null ? '' : parseInt(previousPeriod.split('/')[0]);

	return (
		<div className='form__section'>
			<div className='form__section--header'>
				<h3>3. Household Members and Financial Information</h3>
			</div>

			<div className='form__section--body'>
				<Grid container spacing={3}>
					<Grid item xs={12} lg={7}>
						<div className='section__student-financial'>
							<FinancialInformation ref={financialInformationRef} application={application} account={account} />
						</div>
					</Grid>
					<Grid item xs={12} lg={5}>
						<div className='income__requirement'>
							<h4>INCOME REQUIREMENT</h4>
							{/* <div className='income_requirement-block'>
								• The family’s income cannot exceed 185% of the income limit required to qualify for Reduced Price Meals under the National School Lunch and Child Nutrition Acts.
							</div> */}
							<div className='income_requirement-block'>
								• Submit {previous} IRS Form 1040 pages 1&2 and if more than 4 dependents the Federal Supporting Statement Form 1040 Dependents. If your income is below the income threshold required
								for filing taxes, submit a proof of income.
							</div>
							{/* <h4>185 % OF FEDERAL REDUCED PRICE MEALS GUIDELINE</h4>
							<Button color='primary' size='large' onClick={() => setOpenModal(true)}>
								View Table
							</Button> */}
							{/* [AZLF-133] Sample tax pages for families */}
							<TaxFormSamples />
						</div>
					</Grid>
				</Grid>
			</div>

			{lock && <div className='layer-locked' />}
			<Modal open={openModal} onClose={() => setOpenModal(false)} autoHeight>
				<IncomeTable />
			</Modal>
		</div>
	);
};

export default forwardRef(DDFinancialInformationV2);
